import React from 'react';
import PropTypes from 'prop-types';
import RARadioButtonStep from 'components/RAComponents/RARadioButtonStep/RARadioButtonStep';
import { SUITABILITY_TEST_PROFILE_MODEL_ANSWERS } from 'constants/RAConstants';

export const RadioOption = ({ answers, formActions, handleOptionClick, id, level, questionId, userProfile }) => {
    const profileModel = `${SUITABILITY_TEST_PROFILE_MODEL_ANSWERS}.${questionId}`;

    return (
        <RARadioButtonStep
            key={id}
            disabled={false}
            formActions={formActions}
            profileModel={profileModel}
            radioButtons={answers}
            userProfile={userProfile}
            model={id}
            validateStep={() => handleOptionClick({ level, id })}
        />
    );
};

RadioOption.propTypes = {
    handleOptionClick: PropTypes.func,
    level: PropTypes.string,
    answers: PropTypes.object,
    userProfile: PropTypes.object,
    questionId: PropTypes.string,
    formActions: PropTypes.object,
    id: PropTypes.string,
};
